export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-upload-cloud-b3d0bcf7a5e23c543ff69273dbea9cfa.svg";